import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// import DatePicker from 'react-datepicker';
import { changeDataToYYYY_MM_DD, getToday, changeDateToString } from '../../utils/Date/SupportDate';
import * as dailyReportApi from '../../api/reception/dailyReport';

// import { useSelector } from 'react-redux';
import { actModalChange, actComponentsModal, actModalIsOk, actResetModal } from '../../actions/modal';
import { showLoading, hideLoading } from '../../actions/ui';    
// import ModalNotify from '../../features/ModalNotify';   
import FooterButton from '../../utils/FooterButton';
import ModalNotify from '../../features/ModalNotify';
import Modal2Button from '../../components/RCSumTable/ModalContent/Modal2Button';

const RcDailyReport = () => {
     //const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const textareaRef = useRef(null);
    const auth = useSelector(state => state.auth);
    const { role, branchID } = auth.user;
    const token = useSelector(state => state.token);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [oldDate, setOldDate] = useState(new Date());
    const [file1, setFile1] = useState(null);
    const [uploadStatus1, setUploadStatus1] = useState("");

    const [file2, setFile2] = useState(null);
    const [uploadStatus2, setUploadStatus2] = useState("");

    const [file3, setFile3] = useState(null);
    const [uploadStatus3, setUploadStatus3] = useState("");

    const dispatch = useDispatch();

    const [reportData, setReportData] = useState({
        date: "",
        noShow: 0,
        cancelRoom: 0,
        guestMassage: 0,
        guestRoten: 0,
        massageLine: 0,
        rotenLine: 0,
        roomLine: 0,
        guestBreakfast: 0,
        breakfastRoten: 0,
        massage70Roten: 0,
        massage100Roten: 0,
        walkIn: 0,
        shortTime: 0,
        capacityRoom: 0,
        checkIn: 0,
        checkOut: 0,
        ealryCheckIn: 0,
        lateCheckOut: 0,
        usdVcbBuying: 0,
        usdAzumayaBuying: 0,
        jpyVcbBuying: 0,
        jpyAzumayaBuying: 0,
        usdVcbSelling: 0,
        jpyVcbSelling: 0,
        jpyAzumayaSelling: 0,
        listAttachFile: [],
        note: ''
    });

    useEffect(() => {
        if(token) {
            // make this today
            setSelectedDate(getToday());
            // load data this today
            let d = new Date(selectedDate);

            // Giảm đi 1 ngày
            d.setDate(d.getDate() - 1);

            // Format lại thành yyyy-mm-dd
            // let year = d.getFullYear();
            // let month = String(d.getMonth() + 1).padStart(2, '0');
            // let day = String(d.getDate()).padStart(2, '0');

            // setOldDate(`${year}-${month}-${day}`)
            setOldDate(d)
            loadDataDailyReport(getToday());
        }
    },[token])

    const uploadFile = async (file, typeFile) => {
        if (!file) {
            setUploadStatus1("Please select file.");
            return;
        }

        const formData = new FormData();
        formData.append("uploadFile", file);

        try {
        typeFile === "1" ? setUploadStatus1("Upload ...") : typeFile === "2" ? setUploadStatus2("Upload ...") : setUploadStatus3("Upload ...");
            let branch;

            if (branchID === 99) { branch = "AZHP" }
            else if (branchID === 13) { branch = "AZHP" }
            else if (branchID === 7) { branch = "AZDN" }
            
            const response = await dailyReportApi.updateFileAttachFile(formData, branch, typeFile, token);

            if (response.data) {
                if (response.data.status !== 1) {
                    typeFile === "1" ?  setUploadStatus1("X Error upload file" + response.data.msg) : typeFile === "2" ? setUploadStatus2("X Error upload file" + response.data.msg) : setUploadStatus3("X Error upload file" + response.data.msg);
                } else {
                        typeFile === "1" ?  setUploadStatus1("✅ Success upload file") : typeFile === "2" ? setUploadStatus2("✅ Success upload file") : setUploadStatus3("✅ Success upload file");
                }

                const newList = reportData.listAttachFile ? [...reportData.listAttachFile, ] : [];
                newList.push(response.data.path)
                handleChange('listAttachFile', newList);

            } else {
                typeFile === "1" ? setUploadStatus1("X Error upload file" + response.data.msg) : typeFile === "2" ? setUploadStatus2("X Error upload file" + response.data.msg) : setUploadStatus3("X Error upload file" + response.data.msg);
            }

        } catch (err) {
            console.error(err);
            typeFile === "1" ? setUploadStatus1("Error upload file.") : typeFile === "2" ? setUploadStatus2("Error upload file.") : setUploadStatus3("Error upload file.");
        }
    };

    const handleChange = (field, value) => {
        setReportData(prev => ({
        ...prev,
        [field]: value
        }));
    };

    const autoResizeTextArea = (content) => {
        // Use setTimeout to ensure DOM is ready
        setTimeout(() => {
            const textarea = document.querySelector('.highlight-green');
            if (textarea) {
                textarea.style.height = 'auto';
                textarea.style.height = `${textarea.scrollHeight}px`;
            }
        }, 0);
    };

    function loadDataDailyReport(date) {
        const loadData = async () => {
            try {
             //   setIsLoading(true);
                dispatch(showLoading());
                const response = await dailyReportApi.makeDailyReport(date, "check", token);

                if (response.data.status === 1) {
                    response.data.data.listAttachFile = [];
                    setReportData(response.data.data);  
                                  
                    // Add this line to auto-resize after loading data
                    autoResizeTextArea(response.data.data.note);
                } else {
                    alert('Failed to load report: ' + response.data.msg);
                }

                dispatch(hideLoading());
            } catch (error) {
                alert('Error loading report: ' + error.message);
            } finally {
                dispatch(hideLoading());
            }
        }
        loadData();
    }

    // Add date change handler
    const handleDateChange = (date) => {
     //   console.log('Selected date:', date);
        setSelectedDate(date);
        loadDataDailyReport(date);
    };

    const handleTextAreaResize = (e) => {
        e.target.style.height = 'auto';
        e.target.style.height = e.target.scrollHeight + 'px';
        handleChange('note', e.target.value);
    };

    const onInputChange = (e, typeFile) => {
        if (typeFile === "1") {
            setFile1(e.target.files[0]);
        } else if (typeFile === "2") {
            setFile2(e.target.files[0]);
        } else if (typeFile === "3") {
            setFile3(e.target.files[0]);
        }

        uploadFile(e.target.files[0], typeFile)
    };

    const sendReport = async () => {
           try {
              //  setIsLoading(true);
                const response = await dailyReportApi.sendMailDailyReport(reportData, token);
                
                if (response.data.status === 1) {
                     const openModal = actModalIsOk();
                     dispatch(openModal);

                    const changeModal = actModalChange("centered",
                        "Notification", "Report sent successfully!", "", "")
                    dispatch(changeModal);

                     const changeComponent = actComponentsModal(<Modal2Button
                        buttonName1="Confirm"
                        buttonName2="Close"
                        styleButton1={undefined}
                        styleButton2="btn-danger"
                        onClickButton1={sendReport}
                        onClickButton2={closeModal}
                    />)
                    dispatch(changeComponent);
                } else {
                    alert('Failed to send report: ' + response.data.msg);
                }
            } catch (error) {
                alert('Error sending report: ' + error.message);
            } finally {
                setIsLoading(false);
            }
    };

    function handleSendReport() {
        const changeModal = actModalChange("centered",
            "Confirm send Daily Report", "Would you like to submit this daily report?", "", "")
        dispatch(changeModal);

        const openModal = actModalIsOk();
        dispatch(openModal);

        const changeComponent = actComponentsModal(<Modal2Button
            buttonName1="Confirm"
            buttonName2="Close"
            styleButton1="btn-success"
            styleButton2="btn-danger"
            onClickButton1={sendReport}
            onClickButton2={closeModal}
        />)
        dispatch(changeComponent);

    }

    const resetReport = async () => {
        try {
            //setIsLoading(true);
            const response = await dailyReportApi.makeDailyReport(selectedDate, "refresh", token);

            if (response.data.status === 1) {
                setReportData(response.data.data);

                const openModal = actModalIsOk();
                dispatch(openModal);

                const changeModal = actModalChange("centered",
                    "Notification", "Reset data successfully!", "", "")
                dispatch(changeModal);

                const changeComponent = actComponentsModal(<Modal2Button
                    buttonName1="Confirm"
                    buttonName2="Close"
                    styleButton1={undefined}
                    styleButton2="btn-danger"
                    onClickButton1={sendReport}
                    onClickButton2={closeModal}
                />)

                dispatch(changeComponent);

            } else {
                alert('Failed to load report: ' + response.data.msg);
            }
            setIsLoading(false);
        } catch (error) {
                alert('Error reset report: ' + error.message);
        } finally {
            setIsLoading(false);
        }
     };

    function handleResetReport() {
        const changeModal = actModalChange("centered",
            "Confirm reset data Daily Report", "Would you like reset data daily report?", "", "")
        dispatch(changeModal);

        const openModal = actModalIsOk();
        dispatch(openModal);

        const changeComponent = actComponentsModal(<Modal2Button
            buttonName1="Confirm"
            buttonName2="Close"
            styleButton1="btn-success"
            styleButton2="btn-danger"
            onClickButton1={resetReport}
            onClickButton2={closeModal}
        />)
        dispatch(changeComponent);
    }

    function closeModal() {
        const closeModal = actResetModal();
        dispatch(closeModal);
    }

  return (
    <>
        <ModalNotify closeModal={closeModal} />
        <div className='rc-daily-report' style={{ paddingBottom: '80px' }}>
        {/* <ModalNotify closeModal={closeModal} /> */}
        <h1 className='mb-3'>Reception Daily Report</h1>
                <input
                    selected={selectedDate}
                    onChange={e => handleDateChange(e.target.value)}
                //    dateFormat="yyyy-MM-dd"
                    className="form-control mb-2"
                    value={selectedDate}
                    type="date"
                    style={{ width: '200px', margin:'auto', fontSize:'1.5rem' }}
                />

        {/* <div className="mb-3 d-flex align-items-center">
                <label className="mr-2">Select Date: </label>
                <input
                    selected={selectedDate}
                    onChange={handleDateChange}
                //    dateFormat="yyyy-MM-dd"
                    className="form-control"
                    type="date"
                    style={{ width: '200px' }}
                />
        </div> */}
        <span>
            <div style={{fontSize:'1.8rem'}}>Title: Daily Report {changeDataToYYYY_MM_DD(oldDate)}</div>
            <div style={{fontSize:'1.8rem'}}>* Data Capacity :{changeDataToYYYY_MM_DD(oldDate)}, Check in / out {changeDataToYYYY_MM_DD(selectedDate)}</div>
        </span>
        <div className='d-flex'>
            <div style={{ 
                textAlign : 'left', 
                background: 'aqua', 
                padding: '8px 15px 8px 15px', 
                fontSize: '1.5rem',
                width: '45%'
                }}>
                <p style={{ marginLeft: '20px' }}>
                    1. No show: <input 
                        type="number" 
                        value={reportData.noShow}
                        onChange={(e) => handleChange('noShow', Number(e.target.value))}
                        style={{width: '60px'}}
                    /> <br />
                    2. Cancel room: <input 
                        type="number"
                        value={reportData.cancelRoom}
                        onChange={(e) => handleChange('cancelRoom', Number(e.target.value))}
                        style={{width: '60px'}}
                    /> <br />
                    3. Report:<br />
                    <span style={{ marginLeft: '20px', display: 'block' }}>
                        <span className={ (branchID === 1 || branchID === 7 || branchID === 12 || branchID === 16)  ? '' : 'op-hidden'}>
                            - Guest massage: <input 
                                type="number"
                                value={reportData.guestMassage}
                                onChange={(e) => handleChange('guestMassage', Number(e.target.value))}
                                style={{width: '60px'}}
                            /> 
                            <br />
                        </span>

                        {/* <span className={ (branchID === 1 || branchID === 7 || branchID === 12 || branchID === 16)  ? '' : 'op-hidden'}>
                            - Guest massage 40: <input 
                                type="number"
                                value={reportData.guestMassage40}
                                onChange={(e) => handleChange('guestMassage40', Number(e.target.value))}
                                style={{width: '60px'}}
                            /> 
                            <br />
                        </span>

                        <span className={ (branchID === 1 || branchID === 7 || branchID === 12 || branchID === 16)  ? '' : 'op-hidden'}>
                            - Guest massage 70: <input 
                                type="number"
                                value={reportData.guestMassage70}
                                onChange={(e) => handleChange('guestMassage70', Number(e.target.value))}
                                style={{width: '60px'}}
                            /> 
                            <br />

                        </span>

                        <span className={ (branchID === 1 || branchID === 7 || branchID === 12 || branchID === 16)  ? '' : 'op-hidden'}>
                            - Guest massage 100: <input 
                                type="number"
                                value={reportData.guestMassage100}
                                onChange={(e) => handleChange('guestMassage100', Number(e.target.value))}
                                style={{width: '60px'}}
                            /> 
                            <br />
                        </span> */}

                        {/* <span className={ (branchID === 1 || branchID === 7 || branchID === 12) ? '' : 'op-hidden'}> */}
                        - Guest Roten: <input 
                            type="number"
                            value={reportData.guestRoten}
                            onChange={(e) => handleChange('guestRoten', Number(e.target.value))}
                            style={{width: '60px'}}
                        /> <br />
                         {/* </span> */}
                         <span className={ (branchID === 1 || branchID === 7 || branchID === 12 || branchID === 16)  ? '' : 'op-hidden'}>
                        - Massage Line promotion customers: <input 
                            type="number"
                            value={reportData.massageLine}
                            onChange={(e) => handleChange('massageLine', Number(e.target.value))}
                            style={{width: '60px'}}
                        /> <br />
                        </span>
                        - Rotenburo Line promotion customers: <input 
                            type="number"
                            value={reportData.rotenLine}
                            onChange={(e) => handleChange('rotenLine', Number(e.target.value))}
                            style={{width: '60px'}}
                        /> <br />
                        - Room Line promotion customers: <input 
                            type="number"
                            value={reportData.roomLine}
                            onChange={(e) => handleChange('roomLine', Number(e.target.value))}
                            style={{width: '60px'}}
                        /> <br />
                        - Guest Breakfast: <input 
                            type="number"
                            value={reportData.guestBreakfast}
                            onChange={(e) => handleChange('guestBreakfast', Number(e.target.value))}
                            style={{width: '60px'}}
                        /> <br />
                        - Guest Breakfast + Roten: <input 
                            type="number"
                            value={reportData.breakfastRoten}
                            onChange={(e) => handleChange('breakfastRoten', Number(e.target.value))}
                            style={{width: '60px'}}
                        /> <br />
                        <span className={ (branchID === 1 || branchID === 7 || branchID === 12) || branchID === 16 ? '' : 'op-hidden'}>
                        - Guest Massage 70 mins + Roten: <input 
                            type="number"
                            value={reportData.massage70Roten}
                            onChange={(e) => handleChange('massage70Roten', Number(e.target.value))}
                            style={{width: '60px'}}
                        /> <br />
                        </span>
                        <span className={ (branchID === 1 || branchID === 7 || branchID === 12) || branchID === 16 ? '' : 'op-hidden'}>
                        - Guest Massage 100 mins + Roten: <input 
                            type="number"
                            value={reportData.massage100Roten}
                            onChange={(e) => handleChange('massage100Roten', Number(e.target.value))}
                            style={{width: '60px'}}
                        /> <br />
                        </span>
                        - Walk in: <input 
                            type="number"
                            value={reportData.walkIn}
                            onChange={(e) => handleChange('walkIn', Number(e.target.value))}
                            style={{width: '60px'}}
                        /> <br />
                        - Short time: <input 
                            type="number"
                            value={reportData.shortTime}
                            onChange={(e) => handleChange('shortTime', Number(e.target.value))}
                            style={{width: '60px'}}
                        /> <br />
                        - Capacity room (old day): <input 
                            type="number"
                            value={reportData.capacityRoom}
                            onChange={(e) => handleChange('capacityRoom', Number(e.target.value))}
                            style={{width: '60px'}}
                        />%
                    </span>
                </p>

                <p>* Today<br />
                    <span className="highlight d-flex ml-3">
                        <div style={{width:"85px"}}>- Check in:</div>   
                        <input 
                            type="number"
                            className='mr-5'
                            value={reportData.checkIn}
                            onChange={(e) => handleChange('checkIn', Number(e.target.value))}
                            style={{width: '60px'}}
                    /></span>
                    <span className="highlight d-flex ml-3">
                        <div style={{width:"85px"}}>- Check out:</div> 
                        <input 
                            type="number"
                            className='mr-5'
                            value={reportData.checkOut}
                            onChange={(e) => handleChange('checkOut', Number(e.target.value))}
                            style={{width: '60px'}}
                    /></span>
                    <span className="highlight d-flex ml-3">
                        <div style={{width:"85px"}}>- Early in:</div> 
                        <input 
                            type="number"
                            className='mr-5'
                            value={reportData.ealryCheckIn}
                            onChange={(e) => handleChange('ealryCheckIn', Number(e.target.value))}
                            style={{width: '60px'}}
                    /></span>
                    <span className="highlight d-flex ml-3">
                        <div style={{width:"85px"}}>- Late Out:</div> 
                        <input 
                            type="number"
                            className='mr-5'
                            value={reportData.lateCheckOut}
                            onChange={(e) => handleChange('lateCheckOut', Number(e.target.value))}
                            style={{width: '60px'}}
                    /></span>
                </p>
            </div>
            
            <div style={{background: 'lightgray', padding: '8px 15px 8px 15px', fontSize: '1.5rem', width: '60%' }}>
                <div className="section-title">4. Exchange rate:</div>
            <table>
                <tr>
                    <th rowSpan="2" style={{fontSize:'1.4rem'}}>Rate Date:{changeDataToYYYY_MM_DD()}</th>
                    <th colSpan="2" style={{fontSize:'1.4rem'}}>USD</th>
                    <th colSpan="2" style={{fontSize:'1.4rem'}}>JPY</th>
                </tr>
                <tr>
                    <th style={{fontSize:'1.4rem'}}>VCB</th>
                    <th style={{fontSize:'1.4rem'}}>Azumaya</th>
                    <th style={{fontSize:'1.4rem'}}>VCB</th>
                    <th style={{fontSize:'1.4rem'}}>Azumaya</th>
                </tr>
                <tr>
                    <td style={{fontSize:'1.4rem'}}>Exchange (Buying rate)</td>
                    <td style={{fontSize:'1.4rem'}}>
                        <input 
                            type="number"
                            value={reportData.usdVcbBuying}
                            onChange={(e) => handleChange('usdVcbBuying', Number(e.target.value))}
                            style={{width: '80px',fontSize:'1.4rem'}}
                            step="0.001"
                        />
                    </td>
                    <td style={{fontSize:'1.4rem'}}>
                        <input 
                            type="number"
                            value={reportData.usdAzumayaBuying}
                            onChange={(e) => handleChange('usdAzumayaBuying', Number(e.target.value))}
                            style={{width: '80px',fontSize:'1.4rem'}}
                            step="0.001"
                        />
                    </td>
                    <td style={{fontSize:'1.4rem'}}>
                        <input 
                            type="number"
                            value={reportData.jpyVcbBuying}
                            onChange={(e) => handleChange('jpyVcbBuying', Number(e.target.value))}
                            style={{width: '80px',fontSize:'1.4rem'}}
                            step="0.01"
                        />
                    </td>
                    <td style={{fontSize:'1.4rem'}}>
                        <input 
                            type="number"
                            value={reportData.jpyAzumayaBuying}
                            onChange={(e) => handleChange('jpyAzumayaBuying', Number(e.target.value))}
                        style={{width: '80px',fontSize:'1.4rem'}}
                            step="0.01"
                        />
                    </td>
                </tr>
                <tr>
                    <td style={{fontSize:'1.4rem'}}>Hotel invoice (Selling rate)</td>
                    <td style={{fontSize:'1.4rem'}}>
                        <input 
                            type="number"
                            value={reportData.usdVcbSelling}
                            onChange={(e) => handleChange('usdVcbSelling', Number(e.target.value))}
                            style={{width: '80px',fontSize:'1.4rem'}}
                            step="0.001"
                        />
                    </td>
                    <td style={{fontSize:'1.4rem'}}></td>
                    <td style={{fontSize:'1.4rem'}}>
                        <input 
                            type="number"
                            value={reportData.jpyVcbSelling}
                            onChange={(e) => handleChange('jpyVcbSelling', Number(e.target.value))}
                            style={{width: '80px',fontSize:'1.4rem'}}
                            step="0.01"
                        />
                    </td>
                    <td style={{fontSize:'1.4rem'}}>
                        <input 
                            type="number"
                            value={reportData.jpyAzumayaSelling}
                            onChange={(e) => handleChange('jpyAzumayaSelling', Number(e.target.value))}
                            style={{width: '80px', fontSize:'1.4rem'}}
                            step="0.01"
                        />
                    </td>
                </tr>
            </table>

            <div className="section-title mt-3" >5. Problem & report:</div>
                {(branchID === 7 || branchID == 13 || branchID === 99 ) &&  <div className="max-w-md mx-auto p-6 border rounded-lg shadow">
                    <span className="text-lg font-semibold mb-3 mr-4">Upload file 1</span>
                    <input
                        type="file"
                        accept=".xlsx,.xls,.csv,.pdf,.jpg,.jpeg,.png,.webp"
                        onChange={e => onInputChange(e, "1")}
                    />
                    <span className="mt-3 text-sm text-gray-700" 
                            style={{color: uploadStatus1 === "✅ Success upload file" ? "green" :"red"}}>{uploadStatus1}</span>
                </div>}

                 {(branchID === 7 || branchID == 13 || branchID === 99 ) &&  <div className="max-w-md mx-auto p-6 border rounded-lg shadow">
                    <span className="text-lg font-semibold mb-3 mr-4">Upload file 2</span>

                    <input
                        type="file"
                        accept=".xlsx,.xls,.csv,.pdf,.jpg,.jpeg,.png,.webp"
                        onChange={e => onInputChange(e, "2")}
                    />
                    <span className="mt-3 text-sm text-gray-700" 
                            style={{color: uploadStatus2 === "✅ Success upload file" ? "green" :"red"}}>{uploadStatus2}</span>
                </div>}

                 {(branchID === 7 || branchID == 13 || branchID === 99 ) &&  <div className="max-w-md mx-auto p-6 border rounded-lg shadow">
                    <span className="text-lg font-semibold mb-3 mr-4">Upload file 3</span>

                    <input
                        type="file"
                        accept=".xlsx,.xls,.csv,.pdf,.jpg,.jpeg,.png,.webp"
                        onChange={e => onInputChange(e, "3")}
                    />
                    <span className="mt-3 text-sm text-gray-700" 
                            style={{color: uploadStatus3 === "✅ Success upload file" ? "green" :"red"}}>{uploadStatus3}</span>
                </div>}
                <textarea 
                    className="highlight-green" 
                    placeholder="Please write here..."
                    onChange={handleTextAreaResize}
                    value={reportData.note}
                    style={{
                        width: '100%',
                        minHeight: '200px',
                        padding: '8px',
                        resize: 'none',
                        overflow: 'hidden'
                    }}
                    ref={textareaRef}
                />
            </div>
        </div>

        {/* <div className='mt-3'>
            <button 
                className='btn btn-primary mr-2'
                onClick={handleSendReport}
                disabled={isLoading}
            >
                {isLoading ? 'Sending...' : 'Send Report'}
            </button>
            {/* <button className='btn btn-success mr-2'>View Report</button> 
            <button className='btn btn-danger' onClick={handleResetReport}>Reset</button>
        </div> */}

        </div>
        {role === 0 && <FooterButton
            button1="SEND REPORT"
            button2="RESET REPORT"
            // button3="DOWN EXCEL"
            iconBtn1="faPaperPlane"
            iconBtn2="faCheck"
            // iconBtn3="faSave"
            onClickButton1={handleSendReport}
            onClickButton2={handleResetReport}
            // onClickButton3={props.onDownloadExcel}
        />}
    </>
  );
};

export default RcDailyReport;
